import { useCallback, useEffect, useState } from 'react';

import { pushScrollEvent } from '../lib/analytics';

const VISIBILITY_THRESHOLD = 0.1;

/**
 * Пушит scrollEvent один раз, когда элемент появился во вьюпорте.
 * Возвращает callback-ref, который нужно навесить на элемент.
 *
 * Callback-ref + state вместо useRef: CertificateBlock рендерит null до
 * гидрации (isClient), и обычный ref в эффекте увидел бы null — обсервер
 * не прицепился бы.
 */
export function useScrollEvent(name, { enabled = true } = {}) {
  const [element, setElement] = useState(null);
  const ref = useCallback((node) => setElement(node), []);

  useEffect(() => {
    if (!enabled || !element || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          pushScrollEvent(name);
          observer.disconnect(); // one-shot: событие не должно сыпаться при каждом скролле
        }
      },
      { threshold: VISIBILITY_THRESHOLD }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [element, name, enabled]);

  return ref;
}
